import { useQuery } from "@tanstack/react-query";

import { API_GET_FEATURE_FLAGS } from "constants/apiUrls";
import { QueryKey } from "types/queryKey/queryKey";
import getApiClient from "lib/apiClient/getApiClient";

const FEATURE_FLAG_NAMES = [
  "ciam_enable_pim_user_registration_logout",
  "ciam-pim_okta_passkey_enrollment_enabled",
  "ciam-pim_sardine_enabled",
] as const;
type FeatureFlagMap = Record<(typeof FEATURE_FLAG_NAMES)[number], boolean>;

export const getFeatureFlags = async (): Promise<Partial<FeatureFlagMap>> => {
  const apiClient = getApiClient();
  const query = `?flags=${FEATURE_FLAG_NAMES.join(",")}`;

  return apiClient(API_GET_FEATURE_FLAGS + query).then((res) => res.json());
};

function useGetFeatureFlags() {
  return useQuery<Partial<FeatureFlagMap>>({
    queryKey: [QueryKey.FeatureFlags],
    queryFn: getFeatureFlags,
  });
}

export default useGetFeatureFlags;
